"use client";

import { RefObject, useEffect, useState } from "react";
import * as dayjs from "dayjs";
import relativeTime from "dayjs/plugin/relativeTime";
import { Popover } from "@/components/ui/popover";
import { Badge } from "@/components/ui/badge";
import { Checkbox } from "@/components/ui/checkbox";
import TruckSolidIcon from "@/components/icons/truck-solid";
import BrushSolidIcon from "@/components/icons/brush-solid";
import CubeSolidIcon from "@/components/icons/cube-solid";
import FileStackIcon from "@/components/icons/file-stack";
import CloudTaskIcon from "@/components/icons/cloud-task";
import ShoppingBagSolidIcon from "@/components/icons/shopping-bag-solid";
import BulbSolidIcon from "@/components/icons/bulb-solid";
import ParcelMapIcon from "@/components/icons/parcel-map";
import Link from "next/link";
import { useMedia } from "@/hooks/use-media";
import SimpleBar from "@/components/ui/simplebar";
import { PiCheck } from "react-icons/pi";
import { Title, Text } from "@/components/ui/text";
import { GoBold } from "react-icons/go";
import { GoAlert } from "react-icons/go";
import { GoCircleSlash } from "react-icons/go";
import { Modal } from "@/components/ui/modal";
import Notification from "@/app/shared/Notification/notification";
import useAxiosAuth from "@/hooks/fetch/useAxiosAuth";
import { putNotifSeen } from "@/functions/axios/notification/putNotifSeen";
import RatingModal from "@/app/shared/Notification/ratingModal";
import { Dispatch, SetStateAction } from "react";
import Rate from "@/components/rate";
import { HeartIcon } from "@heroicons/react/24/solid";
import { FaStar } from "react-icons/fa";
import { produce } from "immer";
import EyeIcon from "@/components/icons/eye";
import useFetch from "@/hooks/fetch/useFetch";
import getData from "@/functions/getData";
import { IoInformation } from "react-icons/io5";
import { apis } from "@/static/apis/apis";
import MarkdownRenderer from "@/app/shared/Reactmarkdown/MarkDownRendere";
import momentJalaali from "moment-jalaali";
// import momentJalaali
import { now } from "moment";
import GetDate from "@/functions/GetDate";
import { routes } from "@/config/routes";

// dayjs.extend(relativeTime);

function getStatusBadge(status: string) {
  if (status !== undefined) {
    switch (status.toLowerCase()) {
      case "bid":
        return <GoBold color="blue" />;
      case "warning":
        return <GoAlert color="orange" />;
      case "danger":
        return <GoCircleSlash color="red" />;
      case "rating":
        return <FaStar color="orange" />;
      case "information":
        return <IoInformation />;
      default:
        return status;
    }
  }
}
type StateType = {
  data: any[];
  loading: boolean;
  error: any | null;
};
function NotificationsList({
  setIsOpen,
  data,
  setData,
  setSeen,
}: {
  setIsOpen: React.Dispatch<React.SetStateAction<boolean>>;
  data: StateType;
  setData: Dispatch<SetStateAction<StateType>>;
  setSeen: Dispatch<SetStateAction<boolean>>;
}) {
  const [rateModal, setRateModal] = useState(false);
  const axiosAuth = useAxiosAuth();
  const [modaldata, setModaldata] = useState();
  const [open, setOpen] = useState(false);
  const handleclose = () => {
    setOpen(false);
  };

  const [loading1, setLoading1] = useState(false);
  return (
    <div className="w-[320px] text-left rtl:text-right sm:w-[360px] 2xl:w-[420px]">
      <Modal
        isOpen={open}
        size="sm"
        onClose={() => setOpen(false)}
        overlayClassName="dark:bg-opacity-20 dark:bg-gray-50 dark:backdrop-blur-sm"
        containerClassName="dark:bg-gray-100/90 overflow-hidden my-3 y-64 "
      >
        <Notification data={modaldata} handleclose={handleclose} />
      </Modal>
      <Modal
        isOpen={rateModal}
        size="sm"
        onClose={() => setRateModal(false)}
        overlayClassName="dark:bg-opacity-20 dark:bg-gray-50 dark:backdrop-blur-sm"
        containerClassName="dark:bg-gray-100/90 overflow-hidden my-3 y-64 "
      >
        <RatingModal data={modaldata} handleclose={() => setRateModal(false)} />
      </Modal>
      <div className="mb-3 flex items-center justify-between ps-6">
        <Title as="h5">اعلان ها</Title>
        {/* <Checkbox
          containerClassName="flex flex-row-reverse gap-2 ml-2 h-1"
          label="سین زدن همه"
        /> */}
        <div className="flex flex-row gap-3 justify-start items-center">
          <Text>سین زدن همه</Text>

          <EyeIcon
            className="w-6 h-6 cursor-pointer"
            onClick={async () => {
              var val = await getData(apis.notification.seenAll, axiosAuth);
              if (val != undefined) {
                // setLoading1(true);

                setIsOpen(false);
                setData((prevState) => ({
                  ...prevState,
                  data: val,
                  loading: false,
                  error: null,
                }));
              }
            }}
          />
        </div>
      </div>
      <SimpleBar className="max-h-[420px]">
        {data.data && (
          <div className="grid cursor-pointer grid-cols-1 gap-1 ps-4">
            {data.data.filter((item) => item.status !== "chat").length <= 0 && (
              <p>اعلانی برای شما وجود ندارد.</p>
            )}
            {data.data &&
              data.data
                .filter((item) => item.status !== "chat")
                .map((item, index) =>
                  item.status !== "rating" ? (
                    <div
                      onClick={async () => {
                        setModaldata(item);
                        setOpen(true);
                        if (item.is_seen == false) {
                          var val = await putNotifSeen(axiosAuth, item.id);
                          // item.is_seen = true;
                          setData((x) => {
                            return produce(x, (draft) => {
                              if (draft.data) {
                                draft.data[
                                  data.data.findIndex(
                                    (findItem) => findItem.id == item.id
                                  )
                                ].is_seen = true;
                              }
                            });
                          });
                        }

                        // setIsOpen(false);
                      }}
                      key={item.status + item.id}
                      className="group grid grid-cols-[auto_minmax(0,1fr)] gap-3 rounded-md px-2 py-2 pe-3 transition-colors hover:bg-gray-100 dark:hover:bg-gray-50"
                    >
                      <div className="flex h-9 w-9 items-center justify-center rounded bg-gray-100/70 p-1 dark:bg-gray-50/50 [&>svg]:h-auto [&>svg]:w-5">
                        {getStatusBadge(item.status)}
                      </div>
                      <div className="grid grid-cols-[minmax(0,1fr)_auto] items-center">
                        <div className="w-full">
                          {/* <Title
                            as="h6"
                            className="mb-0.5 w-11/12 truncate text-sm font-semibold"
                          >
                             {item.message} 
                            
                          </Title> */}
                          {item.message != "پیشنهاد شما لغو شد" && (
                            <MarkdownRenderer
                              content={item.message}
                              classname="mb-0.5 w-11/12 truncate text-sm font-semibold"
                            ></MarkdownRenderer>
                          )}
                          {item.message == "پیشنهاد شما لغو شد" && (
                            <div className="mb-2 mt-3">
                            {/* <Text >{data?.message}</Text> */}
                            درخواست شما بر روی 
                            {" "}
                            <Link className="text-primary-light border-b decoration-dashed mx-1" href={routes.invoice.details(item?.advertisement?.id)}>
                            حواله‌ی
                            {" "}{item?.advertisement?.id}{" "}
                            </Link>
                            لغو شد
                          </div>
                          )}
                          <span className="ms-auto whitespace-nowrap pe-8 text-xs text-gray-500">
                            {/* @ts-ignore */}
                            {/* {dayjs(item.create_date).fromNow(true)} */}
                            {/* {momentJalaali(item.create_date).locale('fa').fromNow()} */}
                            <GetDate create_date={item.create_date}></GetDate>
                          </span>
                        </div>
                        <div className="ms-auto flex-shrink-0">
                          {item.is_seen ? (
                            <span className="inline-block rounded-full bg-gray-100 p-0.5 dark:bg-gray-50">
                              <PiCheck className="h-auto w-[12px]" />
                            </span>
                          ) : (
                            <Badge
                              renderAsDot
                              size="lg"
                              color="info"
                              className="scale-90"
                            />
                          )}
                        </div>
                      </div>
                    </div>
                  ) : (
                    <div
                      onClick={async () => {
                        if (item.is_rated == false) {
                          setModaldata(item);

                          setRateModal(true);
                        }
                        // setModaldata(item);
                        // setRateModal(true);

                        if (item.is_seen == false) {
                          var val = await putNotifSeen(axiosAuth, item.id);
                          item.is_seen = true;
                        }
                        // setIsOpen(false);
                      }}
                      key={item.status + item.id}
                      className="group grid grid-cols-[auto_minmax(0,1fr)] gap-3 rounded-md px-2 py-2 pe-3 transition-colors hover:bg-gray-100 dark:hover:bg-gray-50"
                    >
                      <div className="flex h-9 w-9 items-center justify-center rounded bg-gray-100/70 p-1 dark:bg-gray-50/50 [&>svg]:h-auto [&>svg]:w-5">
                        {/* {item.status} */}
                        {getStatusBadge(item.status)}
                      </div>
                      <div className="grid grid-cols-[minmax(0,1fr)_auto] items-center">
                        <div className="w-full">
                          <Title
                            as="h6"
                            className="mb-0.5 w-11/12 truncate text-sm font-semibold"
                          >
                            {item.message}
                          </Title>
                          <span className="ms-auto whitespace-nowrap pe-8 text-xs text-gray-500">
                            {/* @ts-ignore */}
                            {/* {dayjs(item.create_date).fromNow(true)} */}
                            {/* {momentJalaali(item.create_date).locale('fa').fromNow()} */}
                            <GetDate create_date={item.create_date}></GetDate>
                          </span>
                        </div>
                        <div className="ms-auto flex-shrink-0">
                          {item.is_seen ? (
                            <span className="inline-block rounded-full bg-gray-100 p-0.5 dark:bg-gray-50">
                              <PiCheck className="h-auto w-[12px]" />
                            </span>
                          ) : (
                            <Badge
                              renderAsDot
                              size="lg"
                              color="info"
                              className="scale-90"
                            />
                          )}
                        </div>
                      </div>
                    </div>
                  )
                )}
          </div>
        )}
      </SimpleBar>

      {/* <Link
        href={"#"}
        onClick={() => setIsOpen(false)}
        className="-me-6 block px-6 pb-0.5 pt-3 text-center hover:underline"
      >
        View All Activity
      </Link> */}
    </div>
  );
}

export default function NotificationDropdown({
  data,
  children,
  setData,
  setSeen,
}: {
  children: JSX.Element & { ref?: RefObject<any> };
  data?: StateType;
  setData?: Dispatch<SetStateAction<StateType>>;
  setSeen?: Dispatch<SetStateAction<boolean>>;
}) {
  const isMobile = useMedia("(max-width: 480px)", false);
  const [isOpen, setIsOpen] = useState(false);
  return (
    <Popover
      isOpen={isOpen}
      setIsOpen={setIsOpen}
      content={() => (
        <NotificationsList
          data={data ? data : { data: [], loading: false, error: null }}
          setIsOpen={setIsOpen}
          setData={setData ? setData : () => {}}
          setSeen={setSeen ? setSeen : () => {}}
        />
      )}
      shadow="sm"
      placement={isMobile ? "bottom" : "bottom-end"}
      className="z-50 px-0 pb-4 pe-6 pt-5 dark:bg-gray-100 [&>svg]:hidden [&>svg]:dark:fill-gray-100 sm:[&>svg]:inline-flex"
    >
      {children}
    </Popover>
  );
}
